<template>
    <div id="dl_map" style="height:350px;"></div>
</template>

<script>

    export default {
        name: "pvz-map2",
        props: ['lat', 'lon', 'pvz', 'baseurl', 'selected_pvz'],
        mounted () {
            // Установить скрипты для использования яндекс карты
            let scriptYandexMap = document.createElement('script');
            scriptYandexMap.setAttribute('src', 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=7953501d-fb47-43bc-95da-7062a333d962');
            document.head.appendChild(scriptYandexMap);

            // Инициализировать яндекс карту
            scriptYandexMap.addEventListener("load", this.initializeYandexMap);
        },
        data () {
            return {
                localLat: this.lat,
                localLon: this.lon,
                tkIds: [0,0,0,0,0,0],
                localSelectedPvz: this.selected_pvz,
                localBaseUrl: this.baseurl,
            }
        },
        methods: {
            setPvz() {
                this.$store.dispatch('setPvz', this.localSelectedPvz)
                    .catch(() => {})
            },
            /*getCoordData() {
                return new Promise(r => setTimeout(() => {
                    this.coordinates = [
                        [ 52.44, 69.73 ],
                        [ 49.81, 62.12 ],
                    ];
                    r();
                }, 1000));
            },*/
            initializeYandexMap() {
                ymaps.ready(() => {
                    this.map = new ymaps.Map("dl_map", {
                        center: [this.localLat, this.localLon],
                        zoom: 10,
                       /* controls: ['fullscreenControl'],
                        searchControlProvider: 'yandex#search',
                        apiKey: '7953501d-fb47-43bc-95da-7062a333d962',
                        lang: 'ru_RU'*/
                    });

                    //this.getCoordData().then(() => this.setMarkers());
                    this.setMarkers()
                });
            },
            setMarkers() {
                // создаем коллекцию меток
                let terminalsCollection = new ymaps.GeoObjectCollection();

                var index = 0; var preset, caption, hint;

                for (index = 0; index < this.pvz.length; ++index) {
                    if(this.pvz[index].tk_id==1) {
                        caption = 'Деловые линии';
                        preset = 'islands#yellowStretchyIcon';
                    } else if(this.pvz[index].tk_id==2) {
                        caption = 'Boxberry';
                        preset = 'islands#redStretchyIcon';
                    } else if(this.pvz[index].tk_id==3) {
                        caption = 'Axiomus';
                        preset = 'islands#orangeStretchyIcon';
                    } else if(this.pvz[index].tk_id==4) {
                        caption = 'СДЭК';
                        preset = 'islands#darkGreenStretchyIcon';
                    } else {
                        caption = 'IML';
                        preset = 'islands#violetStretchyIcon';
                    }

                    this.tkIds[this.pvz[index].tk_id]++;

                    hint = caption + '<br />' + this.pvz[index].address;
                    if(this.pvz[index].worktime !== undefined) {
                        hint += '<br />время работы:' + this.pvz[index].worktime;
                    }

                    if(typeof this.pvz[index].time !== 'undefined') {
                        hint += '.<br />срок доставки:' + this.pvz[index].time;
                    }

                    hint += '.<br />стоимость доставки:<b>' + this.pvz[index].cost + 'р.</b>';

                    if(this.pvz[index].OnlyPrepaidOrders == 1) {
                        hint += '<br /><em class=\"red\">В данном пункте самовывоза <br />выдаются только предоплаченные заказы, <br />при необходимости выберите другой пункт.</em>';
                    }

                    let myGeoObject = new ymaps.GeoObject({
                        // Описание геометрии.
                        geometry: {
                            type: "Point",
                            coordinates: [this.pvz[index].latitude, this.pvz[index].longitude]
                        },
                        // Свойства.
                        properties: {
                            // Контент метки.
                            iconContent: caption,
                            hintContent: hint,
                            code: this.pvz[index].code,
                            tk_id: this.pvz[index].tk_id,
                            tk_index: index,
                        }
                    }, {
                        // Опции.
                        // Иконка метки будет растягиваться под размер ее содержимого.
                        preset: preset,
                        // Метку нельзя перемещать.
                        draggable: false,
                    });

                    terminalsCollection.add(myGeoObject);
                }

                // добавляем коллекцию на карту
                this.map.geoObjects.add(terminalsCollection);
                this.selectBaloon(terminalsCollection);


                // click on placemark
                terminalsCollection.events.add('click', (e) => {
                    let placemark = e.get('target');

                    let tk_index = placemark.properties.get('tk_index');

                    this.localSelectedPvz = this.pvz[tk_index].tk_id + ';' + this.pvz[tk_index].code;

                    this.selectBaloon(terminalsCollection);

                    this.setPvz();

                });

                // setSwitchPanel begin

                if(this.tkIds[1] > 0) {
                    var btn1 = new ymaps.control.Button({
                        data: {
                            content:'Деловые линии',
                            image: this.localBaseUrl + '/img/pvz/dl24.png',
                            title: 'Пункты выдачи Деловых линий'
                        },
                        options: {
                            size: 'small'
                        }
                    });
                    btn1.select();
                    btn1.events.add('click', function() {
                        terminalsCollection.each(function(geoObject, i) {
                            if(geoObject.properties.get('tk_id')==1) {
                                geoObject.options.set('visible',!btn1.isSelected());
                            }
                        });
                    });
                    this.map.controls.add(btn1, {float: 'left'});
                }
                if(this.tkIds[2] > 0) {
                    var btn2 = new ymaps.control.Button({
                        data: {
                            content:'Boxberry',
                            image: this.localBaseUrl + '/img/pvz/bb24.png',
                            title: 'Пункты выдачи Boxberry'
                        },
                        options: {
                            size: 'small'
                        }
                    });
                    btn2.select();
                    btn2.events.add('click', function() {
                        terminalsCollection.each(function(geoObject, i) {
                            if(geoObject.properties.get('tk_id')==2) {
                                geoObject.options.set('visible',!btn2.isSelected());
                            }
                        });
                    });
                    this.map.controls.add(btn2, {float: 'left'});
                }
                if(this.tkIds[3] > 0) {
                    var btn3 = new ymaps.control.Button({
                        data: {
                            content:'Аксиомус',
                            image: this.localBaseUrl + '/img/pvz/axiomus24.png',
                            title: 'Пункты выдачи Аксиомус'
                        },
                        options: {
                            size: 'small'
                        }
                    });
                    btn3.select();
                    btn3.events.add('click', function() {
                        terminalsCollection.each(function(geoObject, i) {
                            if(geoObject.properties.get('tk_id')==3) {
                                geoObject.options.set('visible',!btn3.isSelected());
                            }
                        });
                    });
                    this.map.controls.add(btn3, {float: 'left'});
                }
                if(this.tkIds[4] > 0) {
                    var btn4 = new ymaps.control.Button({
                        data: {
                            content:'СДЭК',
                            image: this.localBaseUrl + '/img/pvz/sdek24.png',
                            title: 'Пункты выдачи СДЭК'
                        },
                        options: {
                            size: 'small'
                        }
                    });
                    btn4.select();
                    btn4.events.add('click', function() {
                        terminalsCollection.each(function(geoObject, i) {
                            if(geoObject.properties.get('tk_id')==4) {
                                geoObject.options.set('visible',!btn4.isSelected());
                            }
                        });
                    });
                    this.map.controls.add(btn4, {float: 'left'});
                }
                if(this.tkIds[5] > 0) {
                    var btn5 = new ymaps.control.Button({
                        data: {
                            content:'IML',
                            image: this.localBaseUrl + '/img/pvz/iml.png',
                            title: 'Пункты выдачи IML'
                        },
                        options: {
                            size: 'small'
                        }
                    });
                    btn5.select();
                    btn5.events.add('click', function() {
                        terminalsCollection.each(function(geoObject, i) {
                            if(geoObject.properties.get('tk_id')==5) {
                                geoObject.options.set('visible',!btn5.isSelected());
                            }
                        });
                    });
                    this.map.controls.add(btn5, {float: 'left'});
                }

                // setSwitchPanel end


            },
            selectBaloon (terminalsCollection) {

                let selected_pvz_data = this.localSelectedPvz.split(';');
                terminalsCollection.each(function(geoObject, i) {
                    if(geoObject.properties.get('code') == selected_pvz_data[1]) {
                        geoObject.options.set('zIndex','10000');
                        let caption = geoObject.properties.get('iconContent');
                        geoObject.properties.set('iconContent', caption + ' выбран');
                    } else {
                        geoObject.options.set('zIndex','100');
                        let caption = geoObject.properties.get('iconContent');
                        let psc = caption.split(' ');
                        geoObject.properties.set('iconContent', psc[0]);
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
